var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.step == 1
    ? _c("app-reminder-select-documents", {
        attrs: {
          contact: _vm.contact,
          reminders: _vm.reminders,
          "selected-reminders": _vm.selectedReminders,
        },
        on: {
          cancel: function ($event) {
            return _vm.cancel()
          },
          next: function ($event) {
            _vm.step = 2
          },
        },
      })
    : _vm.step == 2
    ? _c("app-reminder-select-templates", {
        attrs: {
          contact: _vm.contact,
          "email-templates": _vm.emailTemplates,
          layouts: _vm.layouts,
          "selected-address": _vm.selectedAddress,
          "selected-email-template": _vm.selectedEmailTemplate,
          "selected-layout": _vm.selectedLayout,
          "selected-template": _vm.selectedTemplate,
          "template-text": _vm.content,
          templates: _vm.templates,
          "download-progress": _vm.downloadProgress,
        },
        on: {
          "update:selectedAddress": function ($event) {
            _vm.selectedAddress = $event
          },
          "update:selected-address": function ($event) {
            _vm.selectedAddress = $event
          },
          "update:selectedEmailTemplate": function ($event) {
            _vm.selectedEmailTemplate = $event
          },
          "update:selected-email-template": function ($event) {
            _vm.selectedEmailTemplate = $event
          },
          "update:selectedLayout": function ($event) {
            _vm.selectedLayout = $event
          },
          "update:selected-layout": function ($event) {
            _vm.selectedLayout = $event
          },
          "update:selectedTemplate": function ($event) {
            _vm.selectedTemplate = $event
          },
          "update:selected-template": function ($event) {
            _vm.selectedTemplate = $event
          },
          "update:templateText": function ($event) {
            _vm.content = $event
          },
          "update:template-text": function ($event) {
            _vm.content = $event
          },
          cancel: function ($event) {
            _vm.step = 1
          },
          next: function ($event) {
            return _vm.openSendModal()
          },
          "download-document": function ($event) {
            return _vm.downloadDocument()
          },
          "print-document": function ($event) {
            return _vm.printDocument()
          },
        },
      })
    : _c(
        "app-send-message",
        {
          attrs: {
            attachements: _vm.emailAttachements,
            content: _vm.emailContent,
            subject: _vm.emailSubject,
            to: _vm.emailRecipient,
            "send-handler": _vm.sendHandler,
            contacts: _vm.emailContacts,
          },
          on: {
            "update:attachements": function ($event) {
              _vm.emailAttachements = $event
            },
            "update:content": function ($event) {
              _vm.emailContent = $event
            },
            "update:subject": function ($event) {
              _vm.emailSubject = $event
            },
            "update:to": function ($event) {
              _vm.emailRecipient = $event
            },
            close: function ($event) {
              _vm.step = 2
            },
            sent: function ($event) {
              return _vm.onMessageSent()
            },
          },
        },
        [
          _vm.canUseReadNotifications()
            ? _c("w-checkbox", {
                attrs: {
                  slot: "left-actions",
                  label: _vm.$ct("add-read-confirmation"),
                },
                slot: "left-actions",
                model: {
                  value: _vm.addReadConfirm,
                  callback: function ($$v) {
                    _vm.addReadConfirm = $$v
                  },
                  expression: "addReadConfirm",
                },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }